import { __extends } from "tslib";
import BSSDynamicControlsComponent from './bss-dynamic-controls-component';
import BSSCheckboxAdditionalServicesComponent from '@main/view/components/bss-checkbox-component/js/bss-checkbox-component--additional-services.js';
import BSSRadioButtonAdditionalServicesComponent from '@main/view/components/bss-radio-button-component/js/bss-radio-button-component--additional-services.js';
import template from '../template/additional-services.hbs';
import { isEmpty, cloneDeep } from 'lodash';
import logger from '@main/externals/bss-package-logger/js/logger';
var templateObject = {
    defaultTemplate: template,
};
var BSSAdditionalServicesComponent = /** @class */ (function (_super) {
    __extends(BSSAdditionalServicesComponent, _super);
    /**
     *
     * @param {String} [_entityTemplate=null] _entityTemplate entity template
     * @param {String} [containerSelector=null] containerSelector component container selector
     * @param {Object} [config=null] config configuration of component
     * @param {EventManager} [eventManager=null] instance of _EventManager
     * @param {Formatter} [formatter=null] instance of Formatter
     * @param {Resolution} [resolution=null] Resolution class for width breakpoint handling
     * @param {Toolbox} [toolbox=null] instance of Toolbox object
     */
    function BSSAdditionalServicesComponent(_entityTemplate, containerSelector, config, eventManager, formatter, resolution, toolbox) {
        var _this = _super.call(this, _entityTemplate, containerSelector, config, eventManager, formatter, resolution, templateObject, toolbox) || this;
        /**
         * @desc actions on a control change
         * @param {Event} ev event object
         * @private
         */
        _this._onControlInputChange = function (ev) {
            var $input = _this._toolbox.$(ev.currentTarget);
            if ($input === null || $input === void 0 ? void 0 : $input.length) {
                if ($input.attr('type') === 'radio') {
                    _this._updateGroupRadioControlsData($input);
                }
                var componentCode = $input.attr('data-code');
                var checked = $input.prop('checked');
                var disabled = $input.prop('disabled');
                // set value changed info to later trigger tagging only when radio really changed value
                $input.attr('data-valuechanged', true);
                var $controlEl = $input.parent(".".concat(_this._CONTROL_CLASS));
                _this._setControlStateStyles({ checked: checked, disabled: disabled, $controlEl: $controlEl });
                _this._updateControlsData({
                    controls: _this._controlsData,
                    inputCode: componentCode,
                    inputChecked: checked,
                    inputDisabled: disabled,
                });
                _super.prototype._triggerRecalculation.call(_this);
            }
        };
        _this._initControls(_super.prototype._getControlsData.call(_this));
        return _this;
    }
    /**
     * @desc prepare controls data defaults
     * @override
     */
    BSSAdditionalServicesComponent.prototype._prepareControlsDefaults = function () {
        _super.prototype._prepareControlsDefaults.call(this);
        // resultData source for controls json
        this._CONTROLS_RESULT_DATA_SOURCE = this._config.resultDataSource;
        // container for all controls
        this._CONTROLS_TOP_CONTAINER_CLASS = 'bss-additional-services_components';
        // single control class
        this._CONTROL_CLASS = 'bss-additional-services_control';
        // single control input class
        this._CONTROL_INPUT_CLASS = 'bss-additional-services_input';
        // additional container for controls children required for indenting
        this._CONTROLS_LIST_CLASS = 'bss-additional-services_list';
        this._CONTROLS_WRAPPER_CLASS = 'bss-to-wrap';
        this._CHECKBOX_CLASS = 'bss-checkbox_cxb-target';
        this._CHECKBOX_PRICE_CLASS = 'bss-checkbox_price';
    };
    /**
     * @desc init controls
     * @param {Array} controlsData array of controls
     * @private
     */
    BSSAdditionalServicesComponent.prototype._initControls = function (controlsData) {
        if (controlsData && Array.isArray(controlsData) && controlsData.length) {
            this._controlsData = controlsData;
            this._renderControls({ controls: this._controlsData });
            this._addControlsListeners();
        }
    };
    /**
     * @desc render controls
     * @param {Object} data object with data required: controls array, groupName used for radios group
     * @private
     */
    BSSAdditionalServicesComponent.prototype._renderControls = function (_a) {
        var _this = this;
        var _b = _a.controls, controls = _b === void 0 ? [] : _b, _c = _a.groupName, groupName = _c === void 0 ? null : _c;
        controls.forEach(function (control) {
            var _a = control || {}, values = _a.values, component_code = _a.component_code, servTariffCode = _a.servTariffCode;
            if (servTariffCode && /FDL/.test(servTariffCode))
                return;
            _this._renderControl({ control: control, groupName: groupName });
            if (values && Array.isArray(values) && values.length) {
                _this._renderControls({ controls: values, groupName: component_code });
                _this._addControlsWrapper({ controls: values });
            }
        });
    };
    /**
     * @desc add controls listeners
     * @private
     */
    BSSAdditionalServicesComponent.prototype._addControlsListeners = function () {
        var $controlsInputs = this._getComponentElement(".".concat(this._CONTROL_INPUT_CLASS));
        if ($controlsInputs === null || $controlsInputs === void 0 ? void 0 : $controlsInputs.length) {
            $controlsInputs.on("change.".concat(this._config.componentId), this._onControlInputChange);
        }
    };
    /**
     * @desc wrap controls in a separate div for a future indenting
     * @param {Object} data object with data required: controls array
     * @private
     */
    BSSAdditionalServicesComponent.prototype._addControlsWrapper = function (_a) {
        var _this = this;
        var _b = _a.controls, controls = _b === void 0 ? [] : _b;
        controls.forEach(function (control) {
            var component_code = (control || {}).component_code;
            // for security reasons - 'elements' in case there is a mistake in BE and there is more than one service with the same component_code
            var $elements = _this._getComponentElement(".".concat(_this._CONTROL_CLASS, "_").concat(_this._productId, "_").concat(_this._secureEmptyString(component_code)));
            if ($elements === null || $elements === void 0 ? void 0 : $elements.length) {
                // wrap control element
                var $elementsNoWrap = $elements.not('.bss-wrapped');
                // for security reasons - take the last one
                var $controlEl = _this._toolbox.$($elementsNoWrap[$elementsNoWrap.length - 1]);
                $controlEl.addClass(_this._CONTROLS_WRAPPER_CLASS);
                // wrap next control error element
                var $controlMessageEl = $controlEl.next() || null;
                if ((($controlMessageEl === null || $controlMessageEl === void 0 ? void 0 : $controlMessageEl.length) &&
                    $controlMessageEl.hasClass('bss-checkbox_error-messages')) ||
                    $controlMessageEl.hasClass('bss-radio-button_error-messages')) {
                    $controlMessageEl.addClass(_this._CONTROLS_WRAPPER_CLASS);
                }
                // wrap next list
                var $controlNextListEl = (($controlMessageEl === null || $controlMessageEl === void 0 ? void 0 : $controlMessageEl.length) &&
                    $controlMessageEl.next(".".concat(_this._CONTROLS_LIST_CLASS))) ||
                    $controlEl.next(".".concat(_this._CONTROLS_LIST_CLASS));
                if ($controlNextListEl === null || $controlNextListEl === void 0 ? void 0 : $controlNextListEl.length) {
                    $controlNextListEl.addClass(_this._CONTROLS_WRAPPER_CLASS);
                }
            }
        });
        var $controlsToWrap = this._getComponentElement(".".concat(this._CONTROLS_WRAPPER_CLASS));
        if ($controlsToWrap === null || $controlsToWrap === void 0 ? void 0 : $controlsToWrap.length) {
            $controlsToWrap.wrapAll("<div class='".concat(this._CONTROLS_LIST_CLASS, "'/>"));
            $controlsToWrap.removeClass(this._CONTROLS_WRAPPER_CLASS);
            $controlsToWrap.addClass('bss-wrapped');
        }
    };
    /**
     * @desc render a single control depending on component type
     * @param {Object} data object with data required: control result data object, groupName used for radios group
     * @private
     */
    BSSAdditionalServicesComponent.prototype._renderControl = function (_a) {
        var _b = _a.control, control = _b === void 0 ? null : _b, _c = _a.groupName, groupName = _c === void 0 ? null : _c;
        var component = (control || {}).component;
        if (this._config.checkboxConfig.customValues) {
            component = this._config.checkboxConfig.customValues.component;
        }
        switch (component) {
            case 'checkbox':
                this._renderCheckBoxComponent({ control: control });
                break;
            case 'radio':
                this._renderRadioComponent({ control: control, groupName: groupName });
                break;
            default:
                logger.error("BSSAdditionalServicesComponent: ".concat(this._config.componentId, " => There is no component definition for a service"));
        }
    };
    /**
     * @desc render a checkbox component
     * @param {Object} data object with data required: control result data object
     * @private
     */
    BSSAdditionalServicesComponent.prototype._renderCheckBoxComponent = function (_a) {
        var _b = _a.control, control = _b === void 0 ? null : _b;
        var checkboxConfig = (this._config || {}).checkboxConfig;
        if (checkboxConfig) {
            var config = cloneDeep(checkboxConfig);
            var customValues = this._config.checkboxConfig.customValues;
            if (customValues) {
                var checked_1 = customValues.checked, description = customValues.description, value = customValues.value, component_code = customValues.component_code, label = customValues.label;
                var customLabel = label
                    .map(function (l) {
                    return control[l];
                })
                    .filter(function (l) { return l != undefined && l != ''; })[0];
                control.checked = control[checked_1];
                control.description = control[description];
                control.value = control[value];
                control.component_code = control[component_code];
                control.label = customLabel;
            }
            var _c = control || {}, disabled = _c.disabled, checked = _c.checked;
            this._setBasicConfigData({ control: control, config: config });
            config.configuration = "<value data-checked='".concat(checked, "' data-disabled='").concat(disabled, "'></value>");
            config.resultDataSource = this._CONTROLS_RESULT_DATA_SOURCE;
            this._updateControlTaggingData({ control: control, config: config, selectorTail: '_cxb' });
            this._initControlComponent({
                config: config,
                control: control,
                module: BSSCheckboxAdditionalServicesComponent,
                type: 'checkbox',
            });
        }
        else {
            logger.error("BSSAdditionalServicesComponent: ".concat(this._config.componentId, " => Missing checkbox component configuration for additional services in ui-description"));
        }
    };
    /**
     * @desc render a radio component
     * @param {Object} data object with data required: control result data object, groupName used for radios group
     * @private
     */
    BSSAdditionalServicesComponent.prototype._renderRadioComponent = function (_a) {
        var _b = _a.control, control = _b === void 0 ? null : _b, _c = _a.groupName, groupName = _c === void 0 ? 'radio' : _c;
        var radioConfig = (this._config || {}).radioConfig;
        if (radioConfig) {
            var config = cloneDeep(radioConfig);
            var _d = control || {}, checked = _d.checked, component_code = _d.component_code, disabled = _d.disabled;
            this._setBasicConfigData({ control: control, config: config });
            config.value = component_code;
            config.groupName = "radioGroup_".concat(groupName, "_").concat(this._productId);
            config.configuration = disabled
                ? "<value data-checked='".concat(checked, "' data-disabled='").concat(disabled, "'></value>")
                : "<value data-checked='".concat(checked, "'></value>");
            this._updateControlTaggingData({
                control: control,
                config: config,
                selectorTail: '_rbtn',
            });
            this._initControlComponent({
                config: config,
                control: control,
                module: BSSRadioButtonAdditionalServicesComponent,
            });
        }
        else {
            logger.error("BSSAdditionalServicesComponent: ".concat(this._config.componentId, " => Missing radio component configuration for additional services in ui-description"));
        }
    };
    /**
     * @desc get controls top container id
     * @returns {String} container id
     * @private
     */
    BSSAdditionalServicesComponent.prototype._getControlContainerId = function () {
        var $controlsContainer = this._getComponentElement(".".concat(this._CONTROLS_TOP_CONTAINER_CLASS));
        return ($controlsContainer === null || $controlsContainer === void 0 ? void 0 : $controlsContainer.length) && $controlsContainer.attr('id');
    };
    /**
     * @desc update control config data needed for tagging
     * @param {Object} data object with data required: control result data object, control configuration, selectorTail as a proper selector ending
     * @private
     */
    BSSAdditionalServicesComponent.prototype._updateControlTaggingData = function (_a) {
        var _b = _a.control, control = _b === void 0 ? {} : _b, _c = _a.config, config = _c === void 0 ? {} : _c, _d = _a.selectorTail, selectorTail = _d === void 0 ? '' : _d;
        if (!isEmpty(config) && !isEmpty(control)) {
            var tagEvent = config.tagEvent;
            var label = control.label;
            // set value presented in tagging
            config.taggingTriggerName = label;
            if (tagEvent === null || tagEvent === void 0 ? void 0 : tagEvent.length) {
                tagEvent.forEach(function (event) {
                    event.selector = "#".concat(config.componentId).concat(selectorTail);
                });
            }
        }
    };
    /**
     * @desc init BSS component
     * @param {Object} data object with data required: control configuration, control result data object, module as BSS component class
     * @private
     */
    BSSAdditionalServicesComponent.prototype._initControlComponent = function (_a) {
        var _b = _a.config, config = _b === void 0 ? {} : _b, _c = _a.control, control = _c === void 0 ? {} : _c, _d = _a.module, module = _d === void 0 ? null : _d, _e = _a.type, type = _e === void 0 ? null : _e;
        if (module && !isEmpty(control) && !isEmpty(config)) {
            try {
                config.resultData = this._config.resultData;
                config.entityInstanceId = this._config.entityInstanceId;
                new module(this._entityTemplate, "#".concat(config.containerId), config, this._eventManager, this._formatter, this._resolution, this._toolbox);
                var $controlEl = this._getComponentElement("#".concat(config.componentId));
                if (($controlEl === null || $controlEl === void 0 ? void 0 : $controlEl.length) && $controlEl.html()) {
                    this._setControlAttributes({
                        control: control,
                        $controlEl: $controlEl,
                        componentId: type === 'checkbox' ? config.componentId : null,
                    });
                }
            }
            catch (err) {
                logger.error("BSSAdditionalServicesComponent: ".concat(this._config.componentId, " => There was a problem with initializing a component"), err);
            }
        }
        else {
            logger.error("BSSAdditionalServicesComponent: ".concat(this._config.componentId, " => Missing required data to initialiaze a component"));
        }
    };
    /**
     * @desc set a control attributes in relation to its definition in result data
     * @param {Object} data object with data required: control result data object, control element in html
     * @private
     */
    BSSAdditionalServicesComponent.prototype._setControlAttributes = function (_a) {
        var _b = _a.control, control = _b === void 0 ? {} : _b, _c = _a.$controlEl, $controlEl = _c === void 0 ? null : _c, _d = _a.componentId, componentId = _d === void 0 ? null : _d;
        if (!isEmpty(control) && ($controlEl === null || $controlEl === void 0 ? void 0 : $controlEl.length)) {
            var checked = control.checked, disabled = control.disabled, component_code = control.component_code;
            var $input = $controlEl.find('input');
            $input.prop('checked', checked || false);
            $input.prop('disabled', disabled || false);
            $input.attr('data-code', this._secureEmptyString(component_code));
            $input.addClass([this._CONTROL_INPUT_CLASS]);
            $controlEl.addClass(this._CONTROL_CLASS);
            if (componentId) {
                var $nameEl = this._getComponentElement("#".concat(componentId, "_title value"));
                var $checkboxEl = this._getComponentElement("#".concat(componentId, " .").concat(this._CHECKBOX_CLASS));
                var $priceEl = this._getComponentElement("#".concat(componentId, " .").concat(this._CHECKBOX_PRICE_CLASS));
                this._setControlStateStyles({ checked: checked, disabled: disabled, $controlEl: $nameEl });
                this._setControlStateStyles({
                    checked: checked,
                    disabled: disabled,
                    $controlEl: $checkboxEl,
                });
                this._setControlStateStyles({
                    checked: checked,
                    disabled: disabled,
                    $controlEl: $priceEl,
                });
            }
            else
                this._setControlStateStyles({ checked: checked, disabled: disabled, $controlEl: $controlEl });
        }
    };
    /**
     * @desc set a control state styles
     * @param {Object} data object with data required: control checked state in result data, control disabled state in result data, control element in html
     * @private
     */
    BSSAdditionalServicesComponent.prototype._setControlStateStyles = function (_a) {
        var _b = _a.checked, checked = _b === void 0 ? false : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.$controlEl, $controlEl = _d === void 0 ? null : _d;
        if ($controlEl === null || $controlEl === void 0 ? void 0 : $controlEl.length) {
            $controlEl.removeClass(['bss-disabled', 'is-checked']);
            if (disabled) {
                $controlEl.addClass('bss-disabled');
            }
            if (checked) {
                $controlEl.addClass('is-checked');
            }
        }
    };
    /**
     * @desc set common configuration data for a control
     * @param {Object} data object with data required: control object in result data, control ui-desc configuration
     * @private
     */
    BSSAdditionalServicesComponent.prototype._setBasicConfigData = function (_a) {
        var _b = _a.control, control = _b === void 0 ? {} : _b, _c = _a.config, config = _c === void 0 ? {} : _c;
        if (!isEmpty(control)) {
            var formatter = this._config.formatter;
            var _d = control || {}, description = _d.description, value = _d.value, label = _d.label, component_code = _d.component_code;
            var id = "additionalService_".concat(this._productId, "_").concat(this._secureEmptyString(component_code));
            config.text = "<value>".concat(label, "</value>");
            config.containerId = this._getControlContainerId();
            config.class = "".concat(config.class, " ").concat(this._CONTROL_CLASS, "_").concat(this._productId, "_").concat(this._secureEmptyString(component_code));
            config.componentId = id;
            config.testId = id;
            if (formatter && value) {
                config.price = "<value>".concat(this._formatter.getFormattedValue(value, formatter), "</value>");
            }
            else if (value) {
                config.price = "<value>".concat(value, "</value>");
            }
            if (description) {
                config.hintText = "<value>".concat(description, "</value>");
            }
        }
    };
    /**
     * @desc secure blanks in string by replacing them with '_'
     * @param {String} input input string
     * @private
     */
    BSSAdditionalServicesComponent.prototype._secureEmptyString = function (input) {
        return input.replace(/\s/g, '_');
    };
    /**
     * @desc get component element by selector
     * @param {String} selector selector string
     * @returns {jQuery | null} jQuery element
     * @private
     */
    BSSAdditionalServicesComponent.prototype._getComponentElement = function (selector) {
        return this._$componentEl.find(selector) || null;
    };
    /**
     * @desc uncheck siblings of clicked radio in controls data object
     * @param {jQuery} $radio radio input element
     * @private
     */
    BSSAdditionalServicesComponent.prototype._updateGroupRadioControlsData = function ($radio) {
        var name = $radio.attr('name');
        var $radioListContainer = $radio.closest(".".concat(this._CONTROLS_LIST_CLASS));
        if ($radioListContainer === null || $radioListContainer === void 0 ? void 0 : $radioListContainer.length) {
            var $radioSiblings = $radioListContainer.find("[name='".concat(name, "']"));
            var self_1 = this;
            $radioSiblings.each(function () {
                var componentCode = self_1._toolbox.$(this).attr('data-code');
                var disabled = self_1._toolbox.$(this).prop('disabled');
                self_1._updateControlsData({
                    controls: self_1._controlsData,
                    inputCode: componentCode,
                    inputChecked: false,
                    inputDisabled: disabled,
                });
            });
        }
    };
    /**
     * @desc update controls data object in relation to a clicked control
     * @param {Object} data object with data required: controls array,
     * inputCode as a clicked control component_code, inputChecked as checked state of a clicked control, inputDisabled as disabled state of a clicked control,
     * @private
     */
    BSSAdditionalServicesComponent.prototype._updateControlsData = function (_a) {
        var _this = this;
        var _b = _a.controls, controls = _b === void 0 ? [] : _b, _c = _a.inputCode, inputCode = _c === void 0 ? null : _c, _d = _a.inputChecked, inputChecked = _d === void 0 ? null : _d, _e = _a.inputDisabled, inputDisabled = _e === void 0 ? null : _e;
        if (inputCode) {
            controls.forEach(function (control) {
                var nodeUpdated = false;
                var _a = control || {}, values = _a.values, component_code = _a.component_code;
                if (inputCode === component_code) {
                    _this._updateControl({ node: control, inputChecked: inputChecked, inputDisabled: inputDisabled });
                    nodeUpdated = true;
                }
                if (values && Array.isArray(values) && values.length && !nodeUpdated) {
                    _this._updateControlsData({
                        controls: values,
                        inputCode: inputCode,
                        inputChecked: inputChecked,
                    });
                }
            });
        }
    };
    /**
     * @desc update a single control data object node in relation to a clicked control
     * @param {Object} data object with data required: node as a single control object, inputChecked as checked state of a clicked control,
     * inputDisabled as disabled state of a clicked control,
     * @private
     */
    BSSAdditionalServicesComponent.prototype._updateControl = function (_a) {
        var _b = _a.node, node = _b === void 0 ? {} : _b, _c = _a.inputChecked, inputChecked = _c === void 0 ? null : _c, _d = _a.inputDisabled, inputDisabled = _d === void 0 ? null : _d;
        if (!isEmpty(node)) {
            var nodeDisabled = node.disabled;
            if (inputChecked !== null) {
                node.checked = inputChecked;
            }
            if (typeof nodeDisabled !== 'undefined' && inputDisabled !== null) {
                nodeDisabled = inputDisabled;
            }
        }
    };
    /**
     * @desc actions on general calculator update: rewrite controls based on BE response
     * @param {String} publisherName name of the publisher
     * @param {Object} updateMap object with new calculated values
     * @override
     */
    BSSAdditionalServicesComponent.prototype.update = function (publisherName, updateMap) {
        _super.prototype.update.call(this, publisherName, updateMap);
        var resultData = (updateMap || {}).resultData;
        var productResultData = resultData[this._productId] || null;
        var controlsResultData = (productResultData &&
            productResultData[this._CONTROLS_RESULT_DATA_SOURCE]) ||
            null;
        var controlsData = controlsResultData && JSON.parse(controlsResultData);
        var $container = this._getComponentElement(".".concat(this._CONTROLS_TOP_CONTAINER_CLASS));
        if ($container === null || $container === void 0 ? void 0 : $container.length) {
            // remove components html
            $container.html('');
            // render components
            this._initControls(controlsData);
        }
    };
    return BSSAdditionalServicesComponent;
}(BSSDynamicControlsComponent));
export default BSSAdditionalServicesComponent;
